// Investigation for manual enrolment

import { useGlobalStore } from '../../../Common/store';
import bindActions from '../../../Common/actions';
import passkeyFlowReducer from '../../store/passkeyFlow';

const { actions } = passkeyFlowReducer;

/**
 * usePasskeyFlow Custom Hook
 */
const usePasskeyFlow: any = () => {
	const { state, dispatch } = useGlobalStore();

	// List of Props
	const { passkeyFlow } = state;

	// List of Actions
	const {
		handlePasskeyEnrollment,
		handleCheckPasskeySupport,
		handlePasskeyFlowReset
	} = actions;

	// Bind Actions
	const passkeyFlowActions = bindActions({
		handlePasskeyEnrollment,
		handleCheckPasskeySupport,
		handlePasskeyFlowReset
	}, dispatch);

	return { passkeyFlow, ...passkeyFlowActions };
}

export default usePasskeyFlow;
